import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { AbsoluteSession } from './AbsoluteSession';
import { selectSbsoluteSessionTimoutFlag } from 'srcAlias/client/state/selectors';
const AbsoluteSessionTimeout = (props) => {
  const absoluteSessionTimoutFlag = useSelector(
    selectSbsoluteSessionTimoutFlag
  );
  return absoluteSessionTimoutFlag ? <AbsoluteSession /> : props.children;
};

AbsoluteSessionTimeout.propTypes = {
  children: PropTypes.node.isRequired,
};
export default AbsoluteSessionTimeout;
